import { render, staticRenderFns } from "./TheBlogPost.vue?vue&type=template&id=99173b1a&scoped=true&"
import script from "./TheBlogPost.vue?vue&type=script&lang=js&"
export * from "./TheBlogPost.vue?vue&type=script&lang=js&"
import style0 from "./TheBlogPost.vue?vue&type=style&index=0&id=99173b1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99173b1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
